import { Button, showDialog, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { createFileRoute } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Page } from '~/components/Page'
import { BpSpinner } from '~/elements'
import { AddKBDialog } from '~/features/knowledge-bases/components'
import { KnowledgeBases } from '~/features/knowledge-bases/components/KnowledgeBases'
import { getApiClient } from '~/stores'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/knowledge-bases/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botId } = Route.useParams()
  const [legacyKbs, setLegacyKbs] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getBotJson = async () => {
      try {
        const botJson = await getApiClient({ workspaceId, botId }).getBotJson({ id: botId })
        setLegacyKbs(botJson.knowledge_base || [])
      } finally {
        setIsLoading(false)
      }
    }

    getBotJson()
  }, [botId, workspaceId])

  if (isLoading) {
    return (
      <Page title="Knowledge Bases">
        <div className="flex items-center justify-center py-12">
          <BpSpinner className="h-20 w-20" />
        </div>
      </Page>
    )
  }

  return (
    <Page
      title="Knowledge Bases"
      primaryActions={
        legacyKbs.length > 0 ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <Button className="h-full w-full md:w-fit" disabled={true}>
                  <Plus />
                  Add Knowledge Base
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                You have knowledge bases that need to be migrated before you can add a new one
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <Button
            className="h-full w-full md:w-fit"
            onClick={(e) => {
              e.stopPropagation()
              showDialog(({ close }) => <AddKBDialog workspaceId={workspaceId} botId={botId} close={close} />, {
                title: 'Create a Knowledge Base',
              })
            }}
          >
            <Plus />
            Add Knowledge Base
          </Button>
        )
      }
    >
      <KnowledgeBases workspaceId={workspaceId} botId={botId} legacyKbs={legacyKbs} />
    </Page>
  )
}
